import React, { useEffect } from "react";
import Modal from "react-modal";
import warning_alert_icon from "../../assets/icons/warning-alert.svg";
import information_dark_icon from "../../assets/icons/information-dark.svg";

import { useTranslation, Trans } from 'react-i18next';
import { prefixedT } from "../../i18n/utils";

import "./Modal.css";

export default function SkipQuestionModal(props) {
  const onCloseModal = () => {
    props?.handleClose();
  };

  const { t, i18n } = useTranslation();

  const confirmClose = () => {
    props?.handleClose();
    setTimeout(() => {
      props?.handleConfirm();
    }, 200);
  };

  const style = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0,0,0,0.5)",
      zIndex: 10010,
    },
    content: {
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)",
      width: "100%",
      maxWidth: "350px",
      border: "0",
      background: "#fff",
      overflow: "auto",
      WebkitOverflowScrolling: "touch",
      borderRadius: "24px",
      outline: "none",
      padding: "0",
    },
  };

  useEffect(() => {}, [props]);

  return (
    <>
      <Modal
        closeTimeoutMS={300}
        isOpen={props.show}
        contentLabel="modal"
        onRequestClose={onCloseModal}
        className={props?.isBocconiDesign ? "bocconi" : "center_modal"}
        overlayClassName="bottom_modal_overlay"
        ariaHideApp={false}
        style={style}
      >
        <div className="modal-content">
          <div className="d-flex justify-content-center">
            <img
              alt="Alert"
              className="noselect header_image_big"
              src={information_dark_icon}
            />
          </div>
          <h2
            id="modalTitle"
            className="modal__title"
            style={{
              textAlign: "center",
              marginBottom: "16px",
              marginTop: "16px",
            }}
          >
            {props?.isSkip
              ? t(prefixedT("MODALS.SKIP_QUESTION_TITLE"))
              :  t(prefixedT("MODALS.CONFIRM_ANSWER_TITLE"))}
          </h2>
          <div style={{ textAlign: "center", marginBottom: "24px" }}>
            <p className="text-secondary">
              {props?.isSkip
                ? props?.isBocconiDesign
                  ? t(prefixedT("MODALS.BLOCKED_QUESTION_TEXT_BOCCONI"))
                  : t(prefixedT("MODALS.BLOCKED_QUESTION_TEXT"))
                : t(prefixedT("MODALS.BLOCKED_QUESTION_TEXT_GENERIC"))}
            </p>
          </div>
          <div className="">
            <button
              id="closeModalButton"
              onClick={confirmClose}
              className="w-100"
            >
              {props?.isSkip
                ? t(prefixedT("BUTTONS.SKIP_AND_GO_NEXT"))
                : t(prefixedT("BUTTONS.CONFIRM_AND_CONTINUE"))}
            </button>
            <button
              id="closeModalButton"
              onClick={onCloseModal}
              className="mt-2 white w-100"
            >
              {t(prefixedT("BUTTONS.DISCARD"))}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}
